import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { filter, Observable } from 'rxjs';
import { DeviceEventView } from 'src/app/data/model/device-event-view';
import { GpsTrackPointView } from 'src/app/data/model/gps-tracking-view';
import { GpsTrackPoint } from 'src/app/data/model/gps_tracking';
import { ServiceOrder } from 'src/app/data/model/service-order';
import { MapFilterDialogComponent } from 'src/app/features/map/components/map-filter/map-filter.component';
import { SharedModule } from '../shared.module';
import {
  CancelConfirmDialogComponent,
  CancelConfirmParams,
} from './cancel-confirm-dialog/cancel-confirm-dialog.component';
import { DialogMapComponent } from '../../features/device-event/dialog-map/dialog-map.component';
import {
  GridFilterParam,
  GridFiltersComponent,
} from './grid-filters/grid-filters.component';
import { SendOrdersComponent, SendOrdersParams } from './send-orders/send-orders.component';
import { MapDialogComponent } from 'src/app/features/map/components/map.component';
import { VehicleQRcode } from 'src/app/data/model/vehicle-qr-code';
import { QRDialogComponent } from './QRDialog/QRcode-dialog.component';
import { ChassisState } from 'src/app/data/model/chassis-state';
import { SafeUrl } from '@angular/platform-browser';
import { Vehicle } from 'src/app/data/model/vehicle';
import { DialogImgComponent } from 'src/app/features/delivery/dialog-img/dialog-img.component';
import { MessageDialogComponent, MessageParams } from './message-dialog/message-dialog.component';
import { SuspendPrintComponent } from './suspend-resume-print/components/suspend-print/suspend-print.component';
import { ResumePrintComponent } from './suspend-resume-print/components/resume-print/resume-print.component';
import { SuspendPdfPrintComponent } from './suspend-pdf-print/suspend-pdf-print.component';
import { OdsReportDialogComponent } from 'src/app/features/custom-reports/components/ods-report-dialog/ods-report-dialog.component';
import { ReadingsDialogComponent } from 'src/app/features/custom-reports/components/readings-dialog/readings-dialog.component';
import { PausesDialogComponent } from 'src/app/features/custom-reports2/components/pauses-dialog/pauses-dialog.component';
import { StopsDialogComponent } from 'src/app/features/custom-reports2/components/stops-dialog/stops-dialog.component';
import { VehicleLastPointMapComponent } from 'src/app/features/vehicle/components/vehicle-last-point-map/vehicle-last-point-map.component';
import { SmartBinMapDialogComponent } from 'src/app/features/smart-bin/components/smart-bin-map-dialog/smart-bin-map-dialog.component';
import { EventDialogSmartBinComponent } from 'src/app/features/smart-bin/components/event-dialog-smart-bin/event-dialog-smart-bin.component';
import { DeviceEvent } from 'src/app/data/model/device-event';
import { DuplicateOrdersComponent } from './duplicate-orders/duplicate-orders.component';
import { WaypointsLapMapDialogComponent } from 'src/app/features/waypoints-lap/components/waypoints-lap-map-dialog/waypoints-lap-map-dialog.component';
import { OdsWaypointsMapDialogComponent } from 'src/app/features/service-order/components/ods-waypoints-map-dialog/ods-waypoints-map-dialog.component';
import { VehicleMapFilterDialogComponent } from 'src/app/features/vehicle/components/vehicle-map-filter-dialog/vehicle-map-filter-dialog.component';
import { Layer } from 'leaflet';
import { ReportTagEventMapDialogComponent } from 'src/app/features/report-tag-event/components/report-tag-event-map-dialog/report-tag-event-map-dialog.component';
import { TaggableResourceRouteMapComponent } from 'src/app/features/taggable-resource-route/components/taggable-resource-route-map/taggable-resource-route-map.component';
import { ContractDataDialogComponent } from 'src/app/features/taggable-resource/components/contract-data-dialog/contract-data-dialog.component';
import { TagDataDialogComponent } from 'src/app/features/taggable-resource/components/tag-data-dialog/tag-data-dialog.component';
import { ReportFilterDialogComponent } from './report-filter-dialog/report-filter-dialog.component';
import { VehicleLastWeighingDialogComponent } from 'src/app/features/vehicle/components/vehicle-last-weighing-dialog/vehicle-last-weighing-dialog.component';
import { Weighings } from 'src/app/data/model/weighing';
import { Commands } from 'src/app/data/model/device-messeges-to-send';
import { PayloadDialog } from 'src/app/features/smart-bin-commands/components/payload-dialog/payload-dialog';

@Injectable({
  providedIn: SharedModule,
})
export class DialogsService {
  alert(arg0: any) {
    throw new Error('Method not implemented.');
  }

  constructor(private dialog: MatDialog) {}

  openReportFilters$(params: GridFilterParam): Observable<object> {
    return this.dialog
      .open<ReportFilterDialogComponent, GridFilterParam, object>(
        ReportFilterDialogComponent,
        {
          width: '30%',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openQRDialog$(qrCodeImageUrl: [SafeUrl, Blob]): Observable<object> {
    //const size =this.getImageSizeFromBlob(qrCodeImageUrl[1]);
    return this.dialog.open<QRDialogComponent, any, object>(QRDialogComponent, {
      width: '370px',
      height:'440px',
      data: qrCodeImageUrl
    })
    .afterClosed()
    .pipe(filter((item) => !!item));
  }
  
  message$(params: MessageParams): Observable<boolean> {
    return this.dialog
      .open<MessageDialogComponent, MessageParams, boolean>(
        MessageDialogComponent,
        {
          width: '30%',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  cancelConfirm$(params: CancelConfirmParams | null=null): Observable<boolean> {
    return this.dialog
      .open<CancelConfirmDialogComponent, CancelConfirmParams, boolean>(
        CancelConfirmDialogComponent,
        {
          width: '30%',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }
  suspendPrintConfirm$(params: CancelConfirmParams | null=null): Observable<boolean> {
    return this.dialog
      .open<SuspendPrintComponent, CancelConfirmParams, boolean>(
        SuspendPrintComponent,
        {
          width: '30%',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openWeighingDialog$(params: Weighings): Observable<object> {
    return this.dialog
      .open<VehicleLastWeighingDialogComponent, Weighings, object>(
        VehicleLastWeighingDialogComponent,
        {
          width: '80%',//'800px',
          height:'20%',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }
  suspendPdfPrintConfirm$(params?: CancelConfirmParams): Observable<boolean> {
    return this.dialog
      .open<SuspendPdfPrintComponent, CancelConfirmParams, boolean>(
        SuspendPdfPrintComponent,
        {
          width: '30%',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }
  resumePrintConfirm$(params?: CancelConfirmParams): Observable<boolean> {
    return this.dialog
      .open<ResumePrintComponent, CancelConfirmParams, boolean>(
        ResumePrintComponent,
        {
          width: '30%',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }
  openGridFilters$(params: GridFilterParam): Observable<object> {
    const screenWidth = window.innerWidth;

    // Example breakpoints
    let dialogWidth = '30%'; // default

    if (screenWidth < 600) {
      dialogWidth = '100%'; // mobile
    } else if (screenWidth < 1000) {
      dialogWidth = '60%'; // tablet
    }
    
    return this.dialog
      .open<GridFiltersComponent, GridFilterParam, object>(
        GridFiltersComponent,
        {
          width: dialogWidth,
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openClientSideFilters$(params: GridFilterParam): Observable<object> {
    return this.dialog
      .open<GridFiltersComponent, GridFilterParam, object>(
        GridFiltersComponent,
        {
          width: '30%',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openMiniMap$(params: any): Observable<object> {
    const screenWidth = window.innerWidth;

    // Example breakpoints
    let dialogWidth = '50%'; // default

    if (screenWidth < 600) {
      dialogWidth = '100%'; // mobile
    } else if (screenWidth < 1000) {
      dialogWidth = '80%'; // tablet
    }
    return this.dialog
      .open<DialogMapComponent, any, object>(
        DialogMapComponent,
        {
          width: dialogWidth,//'800px',
          height:'80%',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openSmartBinMiniMap$(params: any): Observable<object> {
    const screenWidth = window.innerWidth;
    let dialogWidth = '50%'; // default

    if (screenWidth < 600) {
      dialogWidth = '100%'; // mobile
    } else if (screenWidth < 1000) {
      dialogWidth = '80%'; // tablet
    }
    return this.dialog
      .open<SmartBinMapDialogComponent, any, object>(
        SmartBinMapDialogComponent,
        {
          width: dialogWidth,//'800px',
          height:'80%',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openSmartBinEvent$(params: DeviceEvent[]): Observable<object> {
    const screenWidth = window.innerWidth;
    let dialogWidth = '50%'; // default

    if (screenWidth < 600) {
      dialogWidth = '100%'; // mobile
    } else if (screenWidth < 1000) {
      dialogWidth = '80%'; // tablet
    }
    return this.dialog
      .open<EventDialogSmartBinComponent, DeviceEvent[], object>(
        EventDialogSmartBinComponent,
        {
          width: dialogWidth,//'800px',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openLastVehicleMap$(params: any): Observable<object> {
    return this.dialog
      .open<VehicleLastPointMapComponent, any, object>(
        VehicleLastPointMapComponent,
        {
          width: '50%',//'800px',
          height:'80%',
          data: params
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openBinsMap$(params: any): Observable<object> {
    const screenWidth = window.innerWidth;
    let dialogWidth = '50%'; // default

    if (screenWidth < 600) {
      dialogWidth = '100%'; // mobile
    } else if (screenWidth < 1000) {
      dialogWidth = '80%'; // tablet
    }
    return this.dialog
      .open<ReportTagEventMapDialogComponent, any, object>(
        ReportTagEventMapDialogComponent,
        {
          width: dialogWidth,//'800px',
          height:'80%',
          data: params
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openGeneratedRoute$(params: any): Observable<object> {
    return this.dialog
      .open<TaggableResourceRouteMapComponent, any, object>(
        TaggableResourceRouteMapComponent,
        {
          width: '80%',//'800px',
          height:'90%',
          data: params
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openWaypointsMap$(params: any): Observable<object> {
    return this.dialog
      .open<WaypointsLapMapDialogComponent, any, object>(
        WaypointsLapMapDialogComponent,
        {
          width: '50%',//'800px',
          height:'80%',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openODSWaypointsMap$(params: ServiceOrder): Observable<object> {
    return this.dialog
      .open<OdsWaypointsMapDialogComponent, ServiceOrder, object>(
        OdsWaypointsMapDialogComponent,
        {
          width: '50%',//'800px',
          height:'80%',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openImgDialog$(params: any): Observable<object> {
    return this.dialog
      .open<DialogImgComponent, any, object>(
        DialogImgComponent,
        {
          width: '80%',//'800px',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }
  openPausesDialog$(params: any): Observable<object> {
    return this.dialog
      .open<PausesDialogComponent, any, object>(
        PausesDialogComponent,
        {
          width: '80%',//'800px',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }
  openStopsDialog$(params: any): Observable<object> {
    return this.dialog
      .open<StopsDialogComponent, any, object>(
        StopsDialogComponent,
        {
          width: '80%',//'800px',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }
  openOdsReportDialog$(params: any): Observable<object> {
    return this.dialog
      .open<OdsReportDialogComponent, any, object>(
        OdsReportDialogComponent,
        {
          width: '80%',//'800px',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }

  openContractDataDialog$(params: any): Observable<object> {
    return this.dialog
      .open<ContractDataDialogComponent, any, object>(
        ContractDataDialogComponent,
        {
          width: '80%',//'800px',
          data: params
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }
  openTagDataDialog$(params: any): Observable<object> {
    return this.dialog
      .open<TagDataDialogComponent, any, object>(
        TagDataDialogComponent,
        {
          width: '80%',//'800px',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }
  openReportReadingsDialog$(params: any): Observable<object> {
    return this.dialog
      .open<ReadingsDialogComponent, any, object>(
        ReadingsDialogComponent,
        {
          width: '80%',//'800px',
          data: params,
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }
  openMapFilters$(params: Vehicle[]): Observable<object> {
    return this.dialog
      .open<MapFilterDialogComponent, Vehicle[], object>(
        MapFilterDialogComponent,
        {
          width: '50%',
          data: params
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }
  openVehicleMapFilters$(params: Vehicle, layer: L.FeatureGroup): Observable<object> {
    return this.dialog
      .open<VehicleMapFilterDialogComponent, VehicleDialogData, object>(
        VehicleMapFilterDialogComponent,
        {
          width: '50%',
          data: {
            vehicle: params, // Pass `vehicle` (params) here
            layer: layer      // Pass `layer` here
          }
        }
      )
      .afterClosed()
      .pipe(filter((item) => !!item));
  }
  openSmartBinCommands$(params: Commands[]): Observable<object> {
    return this.dialog
     .open<PayloadDialog, Commands[], object>(
      PayloadDialog,
      {
        width: '60%',
        data: params,
      }
     )
     .afterClosed()
     .pipe(filter((item) => !!item));
  }
  openSendOrders$(params: ServiceOrder): Observable<object> {
    return this.dialog
     .open<SendOrdersComponent, ServiceOrder, object>(
      SendOrdersComponent,
      {
        width: '30%',
        data: params,
      }
     )
     .afterClosed()
     .pipe(filter((item) => !!item));
  }
  openDuplicateOrders$(params: ServiceOrder): Observable<object> {
    return this.dialog
     .open<DuplicateOrdersComponent, ServiceOrder, object>(
      DuplicateOrdersComponent,
      {
        width: '30%',
        data: params,
      }
     )
     .afterClosed()
     .pipe(filter((item) => !!item));
  }
}

interface VehicleDialogData {
  vehicle: Vehicle;
  layer: L.FeatureGroup;
}